import { Sparkles, Users } from "lucide-react";
import { Reveal } from "./Reveal";
import { AI_PRACTICE } from "../../data/content";

export const AIPractice = () => (
  <section data-testid="ai-section" className="mx-auto max-w-[1500px] px-6 md:px-12 py-20 md:py-32">
    <div className="rounded-3xl border border-line bg-sand overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12">
        <div className="lg:col-span-7 p-8 md:p-14 lg:border-r border-line">
          <Reveal>
            <p className="overline text-terracotta flex items-center gap-2">
              <Sparkles size={14} /> AI in Practice
            </p>
            <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight leading-[0.95] text-ink">
              {AI_PRACTICE.heading}
            </h2>
            <p className="mt-7 text-base md:text-lg text-stone leading-relaxed max-w-2xl">
              {AI_PRACTICE.body}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-5 p-8 md:p-14 flex flex-col justify-between gap-10 bg-paper">
          <Reveal delay={0.1}>
            <p className="overline text-stone mb-5">Expert Toolset</p>
            <div className="flex flex-wrap gap-2.5">
              {AI_PRACTICE.chips.map((c) => (
                <span
                  key={c}
                  className="rounded-full border border-ink/15 bg-sand px-4 py-2 text-sm text-ink hover:border-terracotta hover:text-terracotta transition-colors duration-300"
                >
                  {c}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="flex items-start gap-4 border-t border-line pt-8">
              <span className="grid place-items-center w-11 h-11 shrink-0 rounded-full bg-ink text-paper">
                <Users size={18} />
              </span>
              <div>
                <p className="font-serif text-2xl text-ink leading-tight">{AI_PRACTICE.badge}</p>
                <p className="mt-1 text-sm text-stone leading-relaxed">
                  Teaching everyday people to use AI with confidence, out in the community.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
